import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, withCtx as _withCtx, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { colspan: "2" }
const _hoisted_2 = { colspan: "2" }
const _hoisted_3 = { colspan: "2" }
const _hoisted_4 = { colspan: "2" }
const _hoisted_5 = { colspan: "2" }

import {SogDataLabelValueType} from "@/shared/ui/types/SogDataLabelValueType";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import {computed} from "vue";
import ShoppingCartItem from "@/shared/model/shoppingCartItem";
import {sortInsuranceExportBlank} from "@/shared/model/InsuranceExportBlank";

interface Props {
  item: {
    id: string,
    productType: string,
    product: string,
    count: number,
    grossPrice: number,
    amount: number,
    manufacturer: string,
    item: ShoppingCartItem | undefined
  }
  isInvoiced: boolean
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'ShoppingCartItemComponent',
  props: {
    item: {},
    isInvoiced: { type: Boolean, default: false }
  },
  setup(__props: any) {


const props = __props


const _exportCardNumber = computed(() => {
  if (props.item.item) {
    if (props.item.item.insuranceExportBlanks.length > 0) {
      return sortInsuranceExportBlank(props.item.item.insuranceExportBlanks).map(t => t.blankNumber).join(", ")
    }
  }
  return undefined
})

const _exportCardInsuranceNumber = computed(() => {
  if (props.item.item) {
    if (props.item.item.insuranceExportBlanks.length > 0) {
      return sortInsuranceExportBlank(props.item.item.insuranceExportBlanks).map(t => t.insuranceNumber).join(", ")
    }
  }
  return undefined
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogCard, null, {
    default: _withCtx(() => [
      _createVNode(SogCardContent, null, {
        default: _withCtx(() => [
          _createElementVNode("table", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_1, [
                _createVNode(SogDataLabel, {
                  value: __props.item.productType
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_2, [
                _createVNode(SogDataLabel, {
                  value: __props.item.product
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_3, [
                _createVNode(SogDataLabel, {
                  value: __props.item.manufacturer
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[0] || (_cache[0] = _createElementVNode("td", null, "Anzahl", -1)),
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: __props.item.count
                }, null, 8, ["value"])
              ])
            ]),
            _withDirectives(_createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_4, [
                _createVNode(SogDataLabel, { value: _exportCardInsuranceNumber.value }, null, 8, ["value"])
              ])
            ], 512), [
              [_vShow, _exportCardInsuranceNumber.value]
            ]),
            _withDirectives(_createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_5, [
                _createVNode(SogDataLabel, { value: _exportCardNumber.value }, null, 8, ["value"])
              ])
            ], 512), [
              [_vShow, _exportCardNumber.value]
            ]),
            _withDirectives(_createElementVNode("tr", null, [
              _cache[1] || (_cache[1] = _createElementVNode("td", null, "Bruttoprämie", -1)),
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: __props.item.grossPrice,
                  "value-type": _unref(SogDataLabelValueType).Money
                }, null, 8, ["value", "value-type"])
              ])
            ], 512), [
              [_vShow, __props.item.grossPrice>0]
            ]),
            _withDirectives(_createElementVNode("tr", null, [
              _cache[2] || (_cache[2] = _createElementVNode("td", null, "Zahlungsbetrag", -1)),
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: __props.item.amount,
                  "value-type": _unref(SogDataLabelValueType).Money
                }, null, 8, ["value", "value-type"])
              ])
            ], 512), [
              [_vShow, __props.isInvoiced && __props.item.amount>0]
            ])
          ])
        ]),
        _: 1
      }),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})